import React, { useState } from "react";
import { useSelector } from "react-redux";
import CustomInput from "../../../Core/Components/CustomInput";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import FilterItem from "../../../Core/Components/FilterItem";
import { severityFilters, typeFilters } from "../Data";
import MoreServiceFilters from "./MoreServiceFilters";
import { LOCATION_TYPE } from "../../Location/Data";
import { useTenantPermission } from "../../../Core/hooks/usePermission";
import { TENANT_PERMISSIONS } from "../../Login/constants";

const ServiceListHeader = ({
  search,
  setSearch,
  filters,
  setFilters,
  setCurrentPage,
}) => {
  const { allLocations } = useSelector((state) => state.locations);

  // tenant level permission
  const hasTenantLocationPermission = useTenantPermission([
    TENANT_PERMISSIONS.LOCATION_MODULE_ACCESS,
  ]);

  const [focus, setFocus] = useState(false);

  const hubFilters = allLocations
    ?.filter((item) => item.type === LOCATION_TYPE.HUB_STATION)
    .map((location) => ({
      id: location.id,
      value: location.name,
    }));

  const onSelect = (key, value) => {
    // whenever applying the filter, the page should be defaulted back to first page
    setCurrentPage(1);

    if (filters[key].includes(value)) {
      const newFilters = filters[key].filter((item) => item !== value);
      setFilters({ ...filters, [key]: newFilters });
    } else {
      setFilters({ ...filters, [key]: [...filters[key], value] });
    }
  };

  return (
    <div className="bg-background-white">
      <div className="px-6 py-3.5 flex items-center justify-between">
        <div className="flex items-center gap-x-3">
          <CustomInput
            intent="search"
            prefix={
              <img src="/assets/icons/search.svg" alt="" className="mr-2" />
            }
            value={search}
            focus={focus}
            border={focus ? "success" : "none"}
            placeholder={focus ? null : "Search Asset Number"}
            onChange={(e) => setSearch(e.target.value)}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            suffix={
              search.length > 0 ? (
                <CloseIcon
                  className="w-4 h-4 cursor-pointer stroke-dark-grey-text"
                  onClick={() => {
                    setFocus(false);
                    setSearch("");
                  }}
                />
              ) : null
            }
          />

          {hasTenantLocationPermission && (
            <FilterItem
              label="Hub Station"
              identifier="hub"
              contentData={hubFilters}
              onSelect={onSelect}
              selectedValues={filters.hub}
              className="max-h-[200px] overflow-y-scroll"
              enableSearch
            />
          )}

          <FilterItem
            label="Type"
            identifier="type"
            contentData={typeFilters}
            onSelect={onSelect}
            selectedValues={filters.type}
            className="max-h-[200px] overflow-y-scroll"
          />

          <FilterItem
            label="Severity"
            identifier="severity"
            customValue
            contentData={severityFilters}
            onSelect={onSelect}
            selectedValues={filters.severity}
            className="max-h-[max]"
          />

          <div className="bg-light-grey w-[1px] h-5 mx-1" />

          <MoreServiceFilters filters={filters} setFilters={setFilters} />
        </div>
      </div>
    </div>
  );
};

export default ServiceListHeader;
